/**
 * @generated SignedSource<<3b78e7c7c393263fc7e23c66c36cd497>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateEmailLayoutHtmlContentInput = {
  htmlContent: string;
  id: string;
};
export type EmailLayoutDetailsViewUpdateHtmlMutation$variables = {
  input: UpdateEmailLayoutHtmlContentInput;
};
export type EmailLayoutDetailsViewUpdateHtmlMutation$data = {
  readonly updateEmailLayoutHtmlContent: {
    readonly htmlContent: string;
    readonly id: string;
    readonly updatedAt: any;
  };
};
export type EmailLayoutDetailsViewUpdateHtmlMutation = {
  response: EmailLayoutDetailsViewUpdateHtmlMutation$data;
  variables: EmailLayoutDetailsViewUpdateHtmlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailLayout",
    "kind": "LinkedField",
    "name": "updateEmailLayoutHtmlContent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "htmlContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLayoutDetailsViewUpdateHtmlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailLayoutDetailsViewUpdateHtmlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c2b9e6e15d6e08cb6577e784f9a8c29c",
    "id": null,
    "metadata": {},
    "name": "EmailLayoutDetailsViewUpdateHtmlMutation",
    "operationKind": "mutation",
    "text": "mutation EmailLayoutDetailsViewUpdateHtmlMutation(\n  $input: UpdateEmailLayoutHtmlContentInput!\n) {\n  updateEmailLayoutHtmlContent(input: $input) {\n    id\n    htmlContent\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d7f165418af585f056675815958e0da";

export default node;
